type InfinexDomain = `https://infinex.xyz${string}`;
type InfinexSubdomain = `https://${string}.infinex.xyz`;
type InfinexSupportDomain = `https://support.infinex.xyz${string}`;
type InfinexAppDomain = `https://app.infinex.xyz${string}`;
type ExternalRoute =
  | InfinexDomain
  | InfinexSubdomain
  | InfinexSupportDomain
  | InfinexAppDomain;
type InternalRoute = `/${string}`;
type Route = ExternalRoute | InternalRoute | '*';

// Account for nested routes structure
type RouteDefinition =
  | Route
  | {
      readonly [key: string]: RouteDefinition;
    };

// Ensures type safety for route definitions
function defineRoutes<T extends { [K: string]: RouteDefinition }>(
  routes: T
): T {
  return routes;
}

export const routes = defineRoutes({
  root: '/',

  v2: {
    authorize: {
      signingRequest: '/v2/authorize-signing-request',
    },
  },

  system: {
    notFound: '*',
  },

  external: {
    website: 'https://infinex.xyz',
    changelog: 'https://infinex.xyz/changelog',
    legals: {
      termsOfUse: 'https://infinex.xyz/legals/terms-of-use',
      privacyPolicy: 'https://infinex.xyz/legals/privacy-policy',
      supportedAssets: 'https://infinex.xyz/legals/supported-assets',
      fees: 'https://infinex.xyz/legals/fees',
    },
    docs: {
      publicPatronNft: 'https://infinex.xyz/patron-nft',
    },
    support: {
      website: 'https://support.infinex.xyz',
      howTo2fa:
        'https://support.infinex.xyz/en/articles/10197732-how-to-set-up-two-factor-authentication-2fa-for-your-infinex-account',
      highPriceImpact:
        'https://support.infinex.xyz/en/articles/10441113-high-price-impact',
    },
  },
});

// Helper type to extract all possible route paths
export type ExtractRoutePaths<T> = T extends Route
  ? T
  : T extends Record<string, unknown>
    ? ExtractRoutePaths<T[keyof T]>
    : never;
